import React from 'react';
import Geographies from '../components/LiveIntel/Geographies';
import '../components/LiveIntel/liveIntel.css';
import '../components/LiveIntel/geoStreams.css';
import '../components/Reports/reports.css';

const GeographiesPage = () => <Geographies />;

export default GeographiesPage;
